export const PANELS = ['General Details', 'Status Log'];
export const PANELS_ROUTES = ['general-details', 'status-log'];

export const DISPENSE_PANEL = 'Dispense';
export const DISPENSE_PANEL_ROUTE = 'dispense';

export const REDEMPTION_PANEL = 'Redemption';
export const REDEMPTION_PANEL_ROUTE = 'redemption';

export const MANUALLY_FREEZE_ALLOWED_STAGES = [
  'partial',
  'batched',
  'sending',
  'frozen',
  'unfrozen',
  'collecting_cash',
  'dispensing',
];
